import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from './components/Modal';
import NewMortgageLoanForm from './NewMortgageLoanForm';
import NewAutoLoanForm from './NewAutoLoanForm';
import NewCreditCardForm from "./NewCreditCardForm";
import NewHelocForm from "./NewHelocForm";

const CreateLoan = ({ isOpen = true, onClose }) => {
  const [loanType, setLoanType] = useState('mortgage'); // default to mortgage
  const navigate = useNavigate();

  const handleLoanTypeChange = (e) => {
    setLoanType(e.target.value);
  };

  const handleClose = () => {
    if (onClose) onClose();
    else navigate(-1);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Create New Debt" width={800}>
      <div className="form-inline-group">
        <label htmlFor="loanType">Select Debt Type: </label>
        <select id="loanType" value={loanType} onChange={handleLoanTypeChange}>
          <option value="mortgage">Mortgage</option>
          <option value="auto_loan">Auto Loan</option>
          <option value="credit_card">Credit Card</option>
          <option value="heloc">HELOC</option>
        </select>
      </div>

      {loanType === 'mortgage' && <NewMortgageLoanForm />}
      {loanType === 'auto_loan' && <NewAutoLoanForm />}
      {loanType === 'credit_card' && <NewCreditCardForm />}
      {loanType === 'heloc' && <NewHelocForm />}
    </Modal>
  );
};

export default CreateLoan;